var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.props.member.is
    ? _c("div", { staticClass: "ship-crew__member" }, [
        _c("img", {
          staticClass: "ship-crew__photo",
          attrs: { src: _setup.props.member.src },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "ship-crew__info" }, [
          _c("div", { staticClass: "ship-crew__name" }, [
            _vm._v(_vm._s(_setup.props.member.name)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ship-crew__position" }, [
            _vm._v(_vm._s(_setup.props.title)),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }